module.exports = 2;


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/context/two.js
 ** module id = 3
 ** module chunks = 1
 **/